import React from "react";
import { Modal } from "react-bootstrap";
import "./Successfull_Modal.css";
import Deposit_Lottie from "../../../animation/deposit_lottie/Deposit_Lottie";

const Successfull_Modal = (props) => {
  setTimeout(() => {
    props?.onHide();
  }, 5000);

  return (
    <section className="Successfull_Modal">
      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="Successfull_Modal modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title>{props?.message}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="animation_holder">{props?.lottie}</div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default Successfull_Modal;
